import './validation_history.css'
import React, { useState, useEffect } from 'react'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Fab from '@mui/material/Fab';
import swal from 'sweetalert';
import Tooltip from '@mui/material/Tooltip';
import { resend_request_order_validation_email } from '../../../../services/for_allServices';


function validation_state(validation_state) {
    return (
        <>
            {
                validation_state === 0
                    ? <Button variant="contained" className="status_deny">{"refus de validation"}</Button>
                    : validation_state === null
                        ? <Button variant="contained" className="status_waiting">{"en cours de validation"}</Button>
                        : <Button variant="contained" className="status_success">{"validé"}</Button>
            }
        </>

    );
}

const headCells = [
    { id: 'date', numeric: false, disablePadding: false, label: 'Date de modification', align: "left" },
    { id: 'validator', numeric: false, disablePadding: false, label: "Validateur", align: "left" },
    { id: 'state', numeric: false, disablePadding: false, label: 'Statut', align: "left" },
    { id: 'comment', numeric: false, disablePadding: false, label: 'Commentaire', align: "left" }
];


export default function Validation_history({ view_validation_history, setview_validation_history, request_history }) {

    const [waiting, setwaiting] = useState(false);

    useEffect(() => {
       //  console.log(view_validation_history);
    }, [])

    function verify_user_validation(order_validation_process, taken_step) {
        let validated = false;
        let i = 0;
        for (let step of order_validation_process) {
            if (step.user == taken_step.user && step.validated == 1) {
                validated = true;
                break;
            }
            i++;
        }
        return validated;
    }

    async function resend_validation_mail(validation_step_infos) {
        swal({
            title: "Etes-vous sûr ?",
            text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then(async (willDelete) => {
                if (willDelete) {
                    setwaiting(true);
                    let formData = new FormData();
                    formData.append("request_order_id",validation_step_infos.request_order_id);
                    formData.append("user",validation_step_infos.user);
                    formData.append("request_code",validation_step_infos.request_code);
                    await resend_request_order_validation_email(formData).then((response)=>{
                       //  console.log(response.data);
                        setview_validation_history(null);
                        swal("Le validateur sera bientôt notifié !", {
                            icon: "success",
                        });
                    }).catch((error)=>{
                       //  console.log(error.response);
                    });
                    setwaiting(false);
                }
            })
    }

    return (
        <Dialog className="validation_history_container" fullWidth={true} maxWidth={'md'} open={view_validation_history != null ? true : false} onClose={() => setview_validation_history(null)} aria-labelledby="form-dialog-title" >
            <DialogTitle id="form-dialog-title">Historique de validation</DialogTitle>
            <DialogContent>
                <div>
                    <TableContainer>
                        <Table className="validation_history_table" >
                            <TableHead>
                                <TableRow>
                                    {
                                        headCells.map((column) => (
                                            <TableCell key={column.id} align={column.align}>{column.label}</TableCell>
                                        ))
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    view_validation_history.length!=0
                                    ?view_validation_history.map((row, index) => (
                                        <TableRow tabIndex={-1} key={index}>

                                            <TableCell align="left" component="th" scope="row">
                                                {new Date(row.updated_at).toLocaleString()}
                                            </TableCell>
                                            <TableCell align="left">
                                                {row.fullName}
                                                {
                                                    request_history==null && row.validated != 1 && !verify_user_validation(view_validation_history,row)
                                                        ? <Tooltip title="Renvoyer l'email de validation" placement="bottom" >
                                                                <Fab size="small" onClick={(e) => resend_validation_mail(row)} color='default' style={{ backgroundColor: '#29c981', color: 'white', marginLeft: '8px' }} className={row.validated == 1 ? "round_button disabled_button" : "round_button"} >
                                                                    <PublishedWithChangesIcon className="my_icon" />
                                                                </Fab>
                                                        </Tooltip>
                                                        : <></>
                                                }

                                            </TableCell>
                                            <TableCell align="left">
                                                <div className='validation_state_container'>
                                                    {validation_state(row.validated)}
                                                </div>
                                            </TableCell>
                                            <TableCell align="left">
                                                {row.comment}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                    :<TableRow>
                                        Aucun historique
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </DialogContent>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Dialog>
    )
}